/**
 * Whether a cancellation is charged, as the screen shows it before saving.
 *
 * The database decides it again with the same rule (app.cancellation_is_charged,
 * migration 0052); this only lets the cancel dialog say the outcome first.
 * Only a patient's cancellation falls under the professional's cutoff, an
 * absence is charged whenever there is one, and exactly the cutoff is enough.
 */

const HOUR = 3600000;

/** Hours between when the patient gave notice and the session's start. */
export const noticeHours = (startsAt, noticeAt) => (new Date(startsAt) - new Date(noticeAt)) / HOUR;

export const isCharged = ({ policyHours, by, startsAt, noticeAt, status = 'cancelled' }) => {
  if (!policyHours) return false;
  if (status === 'no_show') return true;
  return by === 'patient' && noticeHours(startsAt, noticeAt) < policyHours;
};

/** Whole hours left before a session starts, as the patient's dialog says them. */
export const hoursLeft = (startsAt, now = Date.now()) => Math.max(0, Math.floor(noticeHours(startsAt, now)));

/**
 * Whether a patient may cancel a session from their own account (migration
 * 0057): one booked or asked for, that has not started. The database refuses
 * the rest (cancel_my_appointment).
 */
export const patientMayCancel = (session, now = Date.now()) =>
  ['requested', 'scheduled', 'waiting'].includes(session.status)
  && new Date(session.starts_at).getTime() > now;
